"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineEnvConfigService = void 0;
var EnvConfigService_1 = require("./EnvConfigService");
Object.defineProperty(exports, "defineEnvConfigService", { enumerable: true, get: function () { return EnvConfigService_1.defineEnvConfigService; } });
//# sourceMappingURL=index.js.map